import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment'
import { AngularFireAuth } from "@angular/fire/auth";
import { Router } from '@angular/router';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { from, throwError } from 'rxjs';
// import { auth } from 'firebase-admin';


@Injectable({
  providedIn: 'root'
})
export class DataService {


  constructor(
    private http: HttpClient,
    public firebase: AngularFireAuth,
    public authService: AuthService,
    private router: Router

  ) { }

  private static _handleError(err: HttpErrorResponse | any) {
    return Observable.throw(err.message || 'Error: Unable to complete request.');
  }

  getRole() {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/getRole`, { headers: { Authorization: 'Bearer ' + token } });
    }));
    return authedPipe;
  }

  unsubscribeUser(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/user/unsubscribe`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe;
  }

  deleteTemplate(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/template/delete`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe;
  }

  updateReportageActiveOrders(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/reportage/switch-active-orders`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe;
  }

  updateSchoolActiveOrders(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/school/switch-active-orders`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe;
  }

  getStudents(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/students/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe;
  }


  getUsers(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/user/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe
  }

  getTotalUsers(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/totalUser/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe

  }


  getUser(user_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processUser`, { headers: { Authorization: 'Bearer ' + token }, params: { "user_id": user_id } });
    }));
    return authedPipe
  }

  checkUser(params: any): Observable<any> {
    return this.http.post(`${environment.API_URL}/api/checkUser`, params);
  }

  saveUser(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/user`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  resetPassword(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/resetPassword`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  resetPasswordFromLogin(params: any): Observable<any> {

    return this.http.get(`${environment.API_URL}/api/resetPasswordFromLogin`, { params: params })

  }

  deleteUser(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/deleteUser`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }


  getTemplates() {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {

      return this.http
        .get(`${environment.API_URL}/api/template/list`, { headers: { Authorization: 'Bearer ' + token } });
    }));
    return authedPipe
  }

  getTemplate(template_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processTemplate`, { headers: { Authorization: 'Bearer ' + token }, params: { "template_id": template_id } });
    }));
    return authedPipe

  }

  saveTemplate(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/template`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }


  getYearperiods(params: any = null) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/yearperiod/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  getYearperiod(yearperiod_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processYearperiod`, { headers: { Authorization: 'Bearer ' + token }, params: { "yearperiod_id": yearperiod_id } });
    }));
    return authedPipe
  }

  saveYearperiod(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/yearperiod`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }


  getCatalogs() {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/catalogue/list`, { headers: { Authorization: 'Bearer ' + token } });
    }));
    return authedPipe
  }

  getCatalogue(catalogue_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processCatalogue`, { headers: { Authorization: 'Bearer ' + token }, params: { "catalogue_id": catalogue_id } });
    }));
    return authedPipe

  }

  saveCatalogue(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/catalogue`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  deleteCatalogue(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/deleteCatalogue`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  getCatalogueSchoolRelations(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/checkCatalogueRelations`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  getProducts(call_type: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/product/list`, { headers: { Authorization: 'Bearer ' + token }, params: { "type": call_type } });
    }));
    return authedPipe
  }

  updateRelatedProduct(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/updateRelatedProduct`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  public getRelatedProduct(params: any): Observable<any>  {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/relatedproduct`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  getRelatedProducts(params: any): Observable<any>  {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/relatedproduct/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  getReportageRelatedProducts(reportage_id: string): Observable<any>  {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/reportagerelatedproduct/list`, { headers: { Authorization: 'Bearer ' + token }, params: {"reportage_id": reportage_id} });
    }));
    return authedPipe
  }

  getProduct(product_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processProduct`, { headers: { Authorization: 'Bearer ' + token }, params: { "product_id": product_id } });
    }));
    return authedPipe
  }

  saveProduct(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/product`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  deleteProduct(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/deleteProduct`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  getSchools(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/school/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe
  }

  getSchool(school_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processSchool`, { headers: { Authorization: 'Bearer ' + token }, params: { "school_id": school_id } });
    }));
    return authedPipe

  }

  saveSchool(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/school`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }



  getStages(school_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/stage/list`, { headers: { Authorization: 'Bearer ' + token }, params: { "school_id": school_id } });

    }));
    return authedPipe

  }

  getStage(stage_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processStage`, { headers: { Authorization: 'Bearer ' + token }, params: { "stage_id": stage_id } });

    }));
    return authedPipe

  }

  saveStage(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/stage`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }



  getGrades(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/grade/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe

  }

  getGrade(grade_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processGrade`, { headers: { Authorization: 'Bearer ' + token }, params: { "grade_id": grade_id } });

    }));
    return authedPipe

  }

  saveGrade(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/grade`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }



  getLines(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/line/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe

  }

  getLine(line_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processLine`, { headers: { Authorization: 'Bearer ' + token }, params: { "line_id": line_id } });

    }));
    return authedPipe
  }

  saveLine(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/line`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  getStudentphotos(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/studentphoto/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe
  }

  getTotalStudents(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/totalStudent/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe

  }

  getGifts(params) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/gifts/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe

  }

  getTotalReportageProducts(reportageID: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/totalReportageProducts/list`, { headers: { Authorization: 'Bearer ' + token }, params: {'reportage_id': reportageID} });

    }));
    return authedPipe

  }


  getStudentphoto(student_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processStudent`, { headers: { Authorization: 'Bearer ' + token }, params: { "student_id": student_id } });

    }));
    return authedPipe

  }

  saveStudentphoto(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/studentphoto`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  uploadImages(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/uploadImages`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }



  getRelationships(user_id: string, call_type: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/relationship/list`, { headers: { Authorization: 'Bearer ' + token }, params: { "user_id": user_id, "type": call_type } });

    }));
    return authedPipe

  }

  getRelationshipSchoolUsers(user_id: string, call_type: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/relationshipSchoolUsers/list`, { headers: { Authorization: 'Bearer ' + token }, params: { "user_id": user_id, "type": call_type } });

    }));
    return authedPipe

  }

  getRelationshipUserSchools(user_id: string, call_type: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/relationshipUserSchools/list`, { headers: { Authorization: 'Bearer ' + token }, params: { "user_id": user_id, "type": call_type } });

    }));
    return authedPipe

  }

  getRelationship(relationship_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processRelationship`, { headers: { Authorization: 'Bearer ' + token }, params: { "relationship_id": relationship_id } });

    }));
    return authedPipe

  }

  getRelationshipUserSchool(relationship_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processRelationshipUserSchool`, { headers: { Authorization: 'Bearer ' + token }, params: { "relationship_id": relationship_id, "type":"user" } });

    }));
    return authedPipe

  }

  getRelationshipSchoolUser(relationship_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processRelationshipUserSchool`, { headers: { Authorization: 'Bearer ' + token }, params: { "relationship_id": relationship_id, "type":"school" } });

    }));
    return authedPipe

  }

  saveRelationship(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/relationship`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }


  saveRelationshipSchoolUsers(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/relationshipSchoolUsers`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  saveRelationshipUserSchools(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/relationshipUserSchools`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  deleteRelationship(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/deleteRelationship`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  deleteRelationshipSchoolUsers(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/deleteRelationshipSchoolUsers`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  deleteRelationshipUserSchools(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/deleteRelationshipUserSchools`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }


  getStudent(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/student/photos`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe
  }

  getOrders(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/order/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }


  getOrder(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/processOrder`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe

  }

  getProductsOrder(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/productsOrder`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe

  }

  getProductsOrdered(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/productsOrdered/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe
  }

  getReportageProductsOrdered(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/reportageProductsOrdered/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe
  }

  deletePhoto(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/deletePhoto`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe
  }

  getTotalProductsOrdered(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/totalProductsOrdered/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe

  }
  getTotalReportageProductsOrdered(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/totalReportageProductsOrdered/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe

  }

  processProductOrdered(productOrderedID: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/processProductOrdered`, { headers: { Authorization: 'Bearer ' + token }, params: { "productOrderedID": productOrderedID } });

    }));
    return authedPipe

  }

  processAllProductOrdered(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/processAllProductOrdered`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe

  }

  sendEmailTest(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/sendEmailTest`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }


  checkToken() {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/checkToken`, { headers: { Authorization: 'Bearer ' + token } });
    }));
    return authedPipe;


    // return true

  }

  changeLang(lang: string) {


    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/saveLanguage`, { headers: { Authorization: 'Bearer ' + token }, params: { 'lang': lang } });
    }));
    return authedPipe

  }

  getLang() {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/getLanguage`, { headers: { Authorization: 'Bearer ' + token } });
    }));
    return authedPipe
  }


  createReserve(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/reserve`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  addRemoveToShoppingCart(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/addRemoveToShoppingCart`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  addRemoveReportageToShoppingCart(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/addRemoveReportageToShoppingCart`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  public addAlbumToShoppingCart(data: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.post(`${environment.API_URL}/api/addAlbumToShoppingCart`, data, { headers: { Authorization: 'Bearer ' + token }});
    }));
    return authedPipe
  }

  public addSon(data: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.post(`${environment.API_URL}/api/addSon`, data, { headers: { Authorization: 'Bearer ' + token }});
    }));
    return authedPipe
  }

  public updateAlbumQuantity(data: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.post(`${environment.API_URL}/api/update-album-quantity`, data, { headers: { Authorization: 'Bearer ' + token }});
    }));
    return authedPipe
  }

  updateProductQuantity(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/updateProductQuantity`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  getShoppingCart(): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/getShoppingCart`, { headers: { Authorization: 'Bearer ' + token } });
    }));
    return authedPipe
  }

  getTotalShoppingCart( type: boolean = false): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/getTotalShoppingCart`, { headers: { Authorization: 'Bearer ' + token }, params: {'is_shopping_cart': type} });
    }));
    return authedPipe
  }


  proceedToPaymentTPV(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/proceed-to-payment`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  checkStudents(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/check-students`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }
  uploadStudents(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/upload-students`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  // Get type of notifications and template's name
  getTypes(school_reportage_id: string, type: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/getTypes`, { headers: { Authorization: 'Bearer ' + token }, params: { "school_reportage_id": school_reportage_id, "type":type } });
    }));
    return authedPipe

  }

  checkSendNotifications(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/checkSendNotifications`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  sendNotifications(data: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.post(`${environment.API_URL}/api/sendNotifications`, data,{ headers: { Authorization: 'Bearer ' + token } });
    }));
    return authedPipe
  }

  checkProcessOrders(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/checkProcessOrders`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  processOrders(data: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.post(`${environment.API_URL}/api/processOrders`, data,{ headers: { Authorization: 'Bearer ' + token } });
    }));
    return authedPipe
  }

  createAccount(student_id: string, name: string, email: string, phone: string, role: string = 'family', allow_notifications: boolean) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/createAccount`, { headers: { Authorization: 'Bearer ' + token }, params: { "student_id": student_id, "name": name,  "email": email,  "phone": phone,  "role": role, "allow_notifications": allow_notifications } });

    }));
    return authedPipe

  }

  checkReserve(student_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/checkReserve`, { headers: { Authorization: 'Bearer ' + token }, params: { "student_id": student_id } });

    }));
    return authedPipe

  }

  cancelOrder(order_id: string): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/cancelOrder`, { headers: { Authorization: 'Bearer ' + token }, params: { "order_id": order_id } });
    }));
    return authedPipe
  }


  toggle_notifications(user_id: string): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/toggleNotifications`, { headers: { Authorization: 'Bearer ' + token }, params: { "user_id": user_id } });
    }));
    return authedPipe
  }

  checkDeactivateOrders(school_reportage_id: string, type: string): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/checkDeactivateOrders`, { headers: { Authorization: 'Bearer ' + token }, params: { "school_reportage_id": school_reportage_id, type: type } });
    }));
    return authedPipe
  }

  sendToLab(school_id: string): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/sendToLab`, { headers: { Authorization: 'Bearer ' + token }, params: { "school_id": school_id } });
    }));
    return authedPipe
  }

  sendToFtp(school_id: string): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/sendToFtp`, { headers: { Authorization: 'Bearer ' + token }, params: { "school_id": school_id } });
    }));
    return authedPipe
  }

  duplicate_school(school_id: string): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/duplicateSchool`, { headers: { Authorization: 'Bearer ' + token }, params: { "school_id": school_id } });
    }));
    return authedPipe
  }

  sendReportageToLab(reportage_id: string): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/sendReportageToLab`, { headers: { Authorization: 'Bearer ' + token }, params: { "reportage_id": reportage_id } });
    }));
    return authedPipe
  }

  sendReportageToFtp(reportage_id: string): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/sendReportageToFtp`, { headers: { Authorization: 'Bearer ' + token }, params: { "reportage_id": reportage_id } });
    }));
    return authedPipe
  }

  getSchoolReport(school_id: string, relationship_id: string = '', start_date: string = '2000-01-01 00:00:00.000', end_date: string = '2999-01-01 00:00:00.000'): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/getSchoolReport`, { headers: { Authorization: 'Bearer ' + token }, params: { "school_id": school_id, "relationship_id":relationship_id, "start_date": start_date, "end_date": end_date  } });
    }));
    return authedPipe
  }

  getAgencyReport(rangeDate: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/getAgencyReport`, { headers: { Authorization: 'Bearer ' + token }, params: rangeDate });
    }));
    return authedPipe
  }


  getMakneticReport(school_id: string, type:string, start_date: string = '2000-01-01 00:00:00.000', end_date: string = '2999-01-01 00:00:00.000'): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/getMakneticReport`, { headers: { Authorization: 'Bearer ' + token }, params: { "school_id": school_id, "type": type, "start_date": start_date, "end_date": end_date } });
    }));
    return authedPipe
  }

  adminGetStudentPhoto(route: string): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/adminGetStudentPhoto`, { headers: { Authorization: 'Bearer ' + token }, params: { "route": route } });
    }));
    return authedPipe
  }

  getFile(route: string, type: string): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/getFile`, { headers: { Authorization: 'Bearer ' + token }, responseType: 'arraybuffer', params: { "route": route, "type": type} });
    }));
    return authedPipe
  }

  disableCancelOrder(order_id: string): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/disableCancelOrder`, { headers: { Authorization: 'Bearer ' + token }, responseType: 'arraybuffer', params: { "order_id": order_id} });
    }));
    return authedPipe
  }

  printLabel(reference: string, type: string, id_student: string = '', printer: string): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/printLabel`, { headers: { Authorization: 'Bearer ' + token }, params: { "reference": reference, "printer": printer, "type": type, "id_student": id_student} });
    }));
    return authedPipe
  }
  sendInvoiceZip(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/sendInvoiceZip`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe
  }

  // ------------------------------------------------- Reportages ----------------------------------------//
  getReportages(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/reportage/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe
  }

  getReportage(reportage_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processReportage`, { headers: { Authorization: 'Bearer ' + token }, params: { "reportage_id": reportage_id } });
    }));
    return authedPipe

  }

  saveReportage(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/reportage`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
    // return this.http.post(`${environment.API_URL}/api/manager`, params);
  }

  getReportageReport(reportage_id: string, relationship_id: string = ''): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/getReportageReport`, { headers: { Authorization: 'Bearer ' + token }, params: { "reportage_id": reportage_id} });
    }));
    return authedPipe
  }


  getReportageOrderManagementReport(reportage_id: string, relationship_id: string = ''): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/getReportageOrderManagementReport`, { headers: { Authorization: 'Bearer ' + token }, params: { "reportage_id": reportage_id} });
    }));
    return authedPipe
  }


  checkReportageRelationships(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/check-reportage-relationships`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }
  uploadReportageRelationships(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/upload-reportage-relationships`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }


  getRelationshipUserReportages(user_id: string, call_type: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/relationshipUserReportages/list`, { headers: { Authorization: 'Bearer ' + token }, params: { "user_id": user_id, "type": call_type } });

    }));
    return authedPipe

  }


  getRelationshipUserReportage(relationship_id: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http
        .get(`${environment.API_URL}/api/processRelationshipUserReportage`, { headers: { Authorization: 'Bearer ' + token }, params: { "relationship_id": relationship_id, "type":"user" } });

    }));
    return authedPipe

  }


  deleteRelationshipUserReportages(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/deleteRelationshipUserReportages`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  saveRelationshipUserReportages(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/relationshipUserReportages`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }


  getRelatedReportages(user_id: string, call_type: string) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/relatedReportages/list`, { headers: { Authorization: 'Bearer ' + token }, params: { "user_id": user_id, "type": call_type } });

    }));
    return authedPipe

  }


  changeStatusTodownloaded(photo_id: string):  Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/changeStatusTodownloaded`, { headers: { Authorization: 'Bearer ' + token }, params: { "photo_id": photo_id} });

    }));
    return authedPipe

  }

  uploadReportageImages(params: any): Observable<any> {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/uploadReportageImages`, { headers: { Authorization: 'Bearer ' + token }, params: params });
    }));
    return authedPipe
  }

  getReportagePhoto(reportageID: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/reportagephoto`, { headers: { Authorization: 'Bearer ' + token }, params: {"reportage_id": reportageID} });

    }));
    return authedPipe
  }

  getReportagePhotos(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/reportagephoto/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe
  }


  getallreportagesphoto(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/allreportagesphoto/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe
  }

  getTotalAllreportagesphoto(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/totalAllreportagesphoto/list`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe
  }

  deleteReportagePhoto(params: any) {
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.get(`${environment.API_URL}/api/deleteReportagePhoto`, { headers: { Authorization: 'Bearer ' + token }, params: params });

    }));
    return authedPipe
  }

  public toggleYearperiodStatus(data: any){
    let authedPipe = from(this.authService.getIdToken()).pipe(mergeMap(token => {
      return this.http.post(`${environment.API_URL}/api/toggle-yearperiod-status`, data, { headers: { Authorization: 'Bearer ' + token }});
    }));
    return authedPipe
  }

}

